import { render, staticRenderFns } from "./detailComplaintAutoClaim.vue?vue&type=template&id=6200ca22&"
import script from "./detailComplaintAutoClaim.vue?vue&type=script&lang=js&"
export * from "./detailComplaintAutoClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports